import { render, staticRenderFns } from "./update-footer-bar.vue?vue&type=template&id=30054f1c&scoped=true&"
import script from "./update-footer-bar.vue?vue&type=script&lang=js&"
export * from "./update-footer-bar.vue?vue&type=script&lang=js&"
import style0 from "./update-footer-bar.vue?vue&type=style&index=0&id=30054f1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30054f1c",
  null
  
)

export default component.exports